// extracted by mini-css-extract-plugin
module.exports = {"changedFieldsList":"changedFieldsList__Dk+sb","listItem":"listItem__0wPDY","fieldName":"fieldName__-FNEW","oldValue":"oldValue__abTNq","deletedValue":"deletedValue__RyAgJ"};